import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCYmWWZYOpWv0s3BndAkv1CEB1NWHqYpBw",
  authDomain: "pubg-tmt-server.firebaseapp.com",
  projectId: "pubg-tmt-server",
  storageBucket: "pubg-tmt-server.appspot.com",
  messagingSenderId: "1021856718275",
  appId: "1:1021856718275:web:4e8117fede58d4af1cb176"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)